import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GetTeamReportListItem } from 'domain/models';

interface ITeamReportListState {
  listTeamReport: GetTeamReportListItem[];
  total: number;
}

const initialState: ITeamReportListState = {
  listTeamReport: [],
  total: 0,
};

export const TeamReportListSlice = createSlice({
  name: 'team-report-list',
  initialState,
  reducers: {
    saveTeamReportList: (
      state,
      action: PayloadAction<{ data: GetTeamReportListItem[]; total: number }>,
    ) => {
      state.listTeamReport = action.payload.data;
      state.total = action.payload.total;
    },
    clearTeamReportList: (state) => {
      state.listTeamReport = [];
      state.total = 0;
    },
  },
});

export const { saveTeamReportList, clearTeamReportList } =
  TeamReportListSlice.actions;

export default TeamReportListSlice.reducer;
